export default __webpack_public_path__ + "web/src/assets/images/plans/git_star_gold@2x.png?[fullhash]";